export class AskidaFaturaIstatistik {
    constructor(public askidaBekleyen: number, public askidanAlinan: number, public toplamOdenenTutar: number) {
    }
}